// On-this-page TOC: generate from post h2/h3, scrollspy, smooth-scroll on click
(function () {
    var content = document.querySelector('.gh-content');
    var linksWrap = document.querySelector('.toc-links');
    var aside = document.querySelector('.article-aside');
    if (!content || !linksWrap || !aside) return;

    var headings = [].slice.call(content.querySelectorAll('h2[id], h3[id]'));
    if (headings.length < 2) return;

    var linkMap = {};
    headings.forEach(function (h) {
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        if (h.tagName === 'H3') a.classList.add('toc-h3');
        a.addEventListener('click', function (e) {
            e.preventDefault();
            h.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.pushState(null, '', '#' + h.id);
        });
        linksWrap.appendChild(a);
        linkMap[h.id] = a;
    });

    aside.hidden = false;

    var currentId = null;
    var setActive = function (id) {
        if (id === currentId) return;
        currentId = id;
        Object.keys(linkMap).forEach(function (k) {
            linkMap[k].classList.toggle('active', k === id);
        });
    };

    // Pick the last heading whose top has crossed the offset line (near top of viewport).
    var updateActive = function () {
        var offset = 140; // px from top; slightly below sticky header
        var current = headings[0];
        for (var i = 0; i < headings.length; i++) {
            if (headings[i].getBoundingClientRect().top - offset <= 0) {
                current = headings[i];
            } else {
                break;
            }
        }
        setActive(current.id);

        // Hide TOC well before the article body scrolls out — before the "Read more" cards appear
        var contentBottom = content.getBoundingClientRect().bottom;
        aside.classList.toggle('toc-out', contentBottom < window.innerHeight * 0.85);
    };

    // Throttle with rAF
    var ticking = false;
    var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
            updateActive();
            ticking = false;
        });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateActive();
})();
